import { Component, Prop, Vue } from "vue-property-decorator";

import QuantityButton from "../quantityButton/quantityButton";

import { localCurrency } from "@/plugins/currency";

@Component({
  components: {
    QuantityButton,
  },
  methods: {
    localCurrency,
  },
})
export default class EditMenuQuantityCard extends Vue {
  @Prop({ default: null }) menu;
  @Prop({ default: 0 }) currentQuantity;
  @Prop({ default: 0 }) currentPrice;

  changeMenuQuantity(newQuantity) {
    this.$emit("on-change-menu-quantity", { menu_id: this.menu.id, count: newQuantity });
  }
}
